const [at, rt] = [btoa(btoa("access_token")), btoa(btoa("refresh_token"))];

// const [at, rt] = [
// 	Buffer.from(Buffer.from("access_token").toString("base64")).toString(
// 		"base64"
// 	),
// 	Buffer.from(Buffer.from("refresh_token").toString("base64")).toString(
// 		"base64"
// 	),
// ];

const encodeToken = (token) => {
	try {
		return JSON.stringify({ tkvrt: token });
	} catch (e) {
		return token;
	}
};
const decodeToken = (token) => {
	try {
		const { tkvrt } = JSON.parse(token);
		return tkvrt;
	} catch (e) {
		return "";
	}
};

function setToken(tokenObj) {
	try {
		localStorage.setItem(at, encodeToken(tokenObj));
	} catch (e) {
		console.log("Local Store error", e);
	}
}

function getAccessToken() {
	let accessToken = "";
	try {
		accessToken = decodeToken(localStorage.getItem(at) || "");
	} catch (e) {
		console.log("Local Store error", e);
	}
	return accessToken;
}

function getRefreshToken() {
	let refreshToken = "";
	try {
		refreshToken = decodeToken(localStorage.getItem(rt) || "");
	} catch (e) {
		console.log("Local Store error", e);
	}
	return refreshToken;
}

function setRefeshToken(tokenObj) {
	try {
		localStorage.setItem(rt, encodeToken(tokenObj));
	} catch (e) {
		console.log("Local Store error", e);
	}
}

function clearToken() {
	localStorage.removeItem(at);
	localStorage.removeItem(rt);
}

const TokenService = {
	setToken: setToken,
	getAccessToken: getAccessToken,
	getRefreshToken: getRefreshToken,
	clearToken: clearToken,
	setRefeshToken: setRefeshToken,
};
export default TokenService;
